import * as React from 'react';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const UserAccountSubscriptionListItem = Atom.createRender(
  ({attributes, classes, generateAttributes, context, data, renderChild}) => {
    const listItemAttributes = attributes.set('role', 'listitem');

    return (
      <div {...generateAttributes(listItemAttributes, classes)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child, context)
        )}
      </div>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Subscription',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Users'), iconName('AccountSubscriptionList')),
  },
  render: UserAccountSubscriptionListItem,
  uiStateOnSelected: 'items',
  showEmpty: true,
  constraints: {
    pinToParent: true,
  },
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          alignItems: 'flex-start',
        },
      },
    },
  },
  fields: {children: TListOfElement},
});

export default config;
